import { useEffect, useMemo } from "react";

/**
 * L'URL locale d'un blob, révoquée dès que le blob change ou que le composant
 * s'en va.
 *
 * Passer par un état obligeait à un rendu de plus à chaque photo affichée, et
 * la première image se montrait avec un `src` vide. Le blob suffit à calculer
 * l'URL pendant le rendu ; seule la révocation a besoin d'un effet, parce
 * qu'elle appartient au démontage. Sans elle, chaque vignette réaffichée
 * laisse une URL derrière elle et le navigateur garde le blob en mémoire
 * aussi longtemps que vit l'onglet.
 */
export const useObjectUrl = (blob: Blob | null | undefined): string => {
  const url = useMemo(() => (blob ? URL.createObjectURL(blob) : ""), [blob]);

  useEffect(() => {
    if (!url) return;
    return () => URL.revokeObjectURL(url);
  }, [url]);

  return url;
};
